import type { CreatePaymentDropinOrderRes, PublishPaymentMethodItem } from '../apis/types/payment'

/** 后端要求结束本次支付，等待用户选择是否使用返回的支付方式重试。 */
export class PaymentRetryError extends Error {
  readonly code = 'RETRY'
  readonly err = true

  constructor(
    public readonly payment_id: string,
    public readonly nextPaymentMethod: PublishPaymentMethodItem,
  ) {
    super('Payment failed')
    this.name = 'PaymentRetryError'
  }
}

// SDK 回调跨 bundle 传递时不依赖 instanceof。
export const isPaymentRetryError = (error: unknown): error is PaymentRetryError => {
  return (
    !!error && typeof error === 'object' && 'code' in error && error.code === 'RETRY'
    && 'nextPaymentMethod' in error
    && !!(error.nextPaymentMethod as PublishPaymentMethodItem | null)?.payment_method_id
  )
}

/** 仅拦截带有新支付方式的 RETRY，其他响应沿用原有渠道处理。 */
export const checkPaymentRetry = (result: CreatePaymentDropinOrderRes): CreatePaymentDropinOrderRes => {
  const method = result?.result_data?.data as PublishPaymentMethodItem | null | undefined
  if (result?.result_data?.code === 'RETRY' && method?.payment_method_id) {
    throw new PaymentRetryError(result.payment_id, method)
  }
  return result
}
